var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZonesummaryiconwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 1.125H14.25M4.875 6.125H10.5M4.875 11.125H14.25M1.75 11.125C1.75 11.2908 1.68415 11.4497 1.56694 11.5669C1.44973 11.6842 1.29076 11.75 1.125 11.75C0.95924 11.75 0.800269 11.6842 0.683058 11.5669C0.565848 11.4497 0.5 11.2908 0.5 11.125C0.5 10.9592 0.565848 10.8003 0.683058 10.6831C0.800269 10.5658 0.95924 10.5 1.125 10.5C1.29076 10.5 1.44973 10.5658 1.56694 10.6831C1.68415 10.8003 1.75 10.9592 1.75 11.125ZM1.75 6.125C1.75 6.29076 1.68415 6.44973 1.56694 6.56694C1.44973 6.68415 1.29076 6.75 1.125 6.75C0.95924 6.75 0.800269 6.68415 0.683058 6.56694C0.565848 6.44973 0.5 6.29076 0.5 6.125C0.5 5.95924 0.565848 5.80027 0.683058 5.68306C0.800269 5.56585 0.95924 5.5 1.125 5.5C1.29076 5.5 1.44973 5.56585 1.56694 5.68306C1.68415 5.80027 1.75 5.95924 1.75 6.125ZM1.75 1.125C1.75 1.29076 1.68415 1.44973 1.56694 1.56694C1.44973 1.68415 1.29076 1.75 1.125 1.75C0.95924 1.75 0.800269 1.68415 0.683058 1.56694C0.565848 1.44973 0.5 1.29076 0.5 1.125C0.5 0.95924 0.565848 0.800269 0.683058 0.683058C0.800269 0.565848 0.95924 0.5 1.125 0.5C1.29076 0.5 1.44973 0.565848 1.56694 0.683058C1.68415 0.800269 1.75 0.95924 1.75 1.125Z",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZonesummaryiconwhite);
export default __webpack_public_path__ + "static/media/zonesummaryiconwhite.e9855170940f6c17cd24e332b704c861.svg";
export { ForwardRef as ReactComponent };